import React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';

import * as types from '../../reducer/constants';
import { getNumberValue } from '../../helper';

const FieldRefillMinimumQuantity = ({ form, dispatchServiceData }) => {
  const {
    refill: { refill_minimal_quantity },
  } = form;

  const onChangeDispatch = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_MINIMUM_QUANTITY, value })
  }

  const onChange = (value) => {
    const minimalQuantityValue = getNumberValue(value);
    if (!_.isBoolean(minimalQuantityValue)) {
      onChangeDispatch(minimalQuantityValue);
    }
  };

  const onBlur = (value) => {
    const valueNumber = parseInt(value, 10);
    if (_.isNaN(valueNumber) || _.isNull(value)) {
      onChangeDispatch(1);
    }
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="refill_minimal_quantity">Minimum quantity to refill</ControlLabel>
        <FormControl
          type="text"
          id="refill_minimal_quantity"
          name="refill_minimal_quantity"
          value={refill_minimal_quantity || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur(e.target.value)}
        />
      </FormGroup>
    </>
  );
};

FieldRefillMinimumQuantity.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldRefillMinimumQuantity;
